import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { trackEvent } from "../../../helpers/analytics";
import { useFormContext } from "./context/FormContext";
import { getComponentToRender } from "./components/getComponentToRender";

import "./styles.scss";
import { ILoggedInStatus, useGetLoggedInStatus } from "../../LoggedInStatus";
import { CTA } from "./components/CTA";

export const MultiStepForm = () => {
  const { step } = useFormContext();
  const loginStatus = useGetLoggedInStatus();

  // Track form abandonment
  useEffect(() => {
    trackEvent("ff2 view");
  }, []);

  if (loginStatus === ILoggedInStatus.LOGGED_IN) {
    return (
      <div className="heroff2-form-wrapper">
        <h2 style={{ textAlign: "center" }}>
          Looks like you're already signed in.
          <br />
          Ready to continue your application?
        </h2>
        <CTA
          style={{ maxWidth: "400px" }}
          onClick={() => {
            window.location.assign("/account/login/confirmed");
          }}
        >
          Continue
        </CTA>
      </div>
    );
  }

  const componentToRender = getComponentToRender(step);

  return (
    <motion.div
      className="heroff2-form-wrapper"
      key={step}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      {componentToRender}
    </motion.div>
  );
};
